// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"a6340ea83f81a972","3077":"6dc713245f792058","3128":"6dc713245f792058"}[chunkId] + ".css";
};